import { removeDuplicates } from '~/utils/removeDuplicates';
import type { ICampaignGroup } from '../types';
import { deepCopy } from '~/utils';
import { create } from 'zustand';

export interface ICampaignGroupStoreState {
  campaignGroups: ICampaignGroup[];
  isQueryByCampaignGroups: boolean;
  isQueryByCampaignGroupById: boolean;
}
export interface CampaignGroupStore extends ICampaignGroupStoreState {
  forceSetCampaignGroups: (campaignGroups: ICampaignGroup[]) => void;
  setIsQueryByCampaignGroups: (isQueryByCampaignGroups: boolean) => void;
  setIsQueryByCampaignGroupId: (isQueryByCampaignGroupById: boolean) => void;
  findCampaignGroupById: (id?: ICampaignGroup['id']) => ICampaignGroup | undefined;
  removeCampaignGroupById: (id: ICampaignGroup['id']) => void;
  appendCampaignGroups: (newCampaignGroups: ICampaignGroup[]) => void;
  setCampaignGroups: (campaignGroups: ICampaignGroup[]) => void;
  upsertCampaignGroup: (campaignGroup: ICampaignGroup) => void;
}

export const useCampaignGroupStore = create<CampaignGroupStore>()((set, get) => ({
  campaignGroups: [],
  isQueryByCampaignGroups: false,
  isQueryByCampaignGroupById: false,
  forceSetCampaignGroups: (data) => set({ campaignGroups: data }),
  setIsQueryByCampaignGroupId: (isQueryByCampaignGroupById) => set({ isQueryByCampaignGroupById }),
  setIsQueryByCampaignGroups: (isQueryByCampaignGroups) => set({ isQueryByCampaignGroups }),

  findCampaignGroupById: (id) => {
    if (!id) return;

    const campaignGroups = get().campaignGroups;
    return campaignGroups ? campaignGroups.find((c) => c.id === id) : undefined;
  },
  setCampaignGroups: (campaignGroups) => set({ campaignGroups }),
  appendCampaignGroups: (campaignGroups) => {
    const currentCampaignGroups = deepCopy(get().campaignGroups) || [];
    const newCampaignGroups = [...currentCampaignGroups, ...campaignGroups];
    const newCampaignGroupsDuplicated = removeDuplicates(newCampaignGroups, ['id']);
    set({ campaignGroups: newCampaignGroupsDuplicated });
  },
  upsertCampaignGroup: (campaignGroup) => {
    set((state) => {
      const campaignGroupCopy = deepCopy(campaignGroup);
      const dataCampaignGroups = deepCopy(state.campaignGroups) || [];
      const currentCampaignGroups = removeDuplicates(dataCampaignGroups, ['id']);
      const index = currentCampaignGroups.findIndex((c) => c.id === campaignGroupCopy.id);

      let dataUpdated;
      if (index !== -1) {
        // Update existing campaignGroup
        dataUpdated = [...currentCampaignGroups];
        dataUpdated[index] = {
          ...dataUpdated[index],
          ...campaignGroup,
        } as ICampaignGroup;
      } else {
        // Insert new campaignGroup
        dataUpdated = [...currentCampaignGroups, campaignGroupCopy];
      }
      return {
        campaignGroups: dataUpdated,
      };
    });
    // set({ campaignGroups: dataUpdated });
  },
  removeCampaignGroupById: (id) => {
    const campaignGroups = get().campaignGroups || [];
    set({ campaignGroups: campaignGroups.filter((item) => item.id !== id) });
  },
}));
